import { RouteConfig } from "vue-router";
import Schemes from "defi/views/schemes.vue";
import Mine from "defi/views/mine.vue";
import ContractsList from "defi/views/_type/contracts/index";
import ContractItem from "defi/views/_type/contracts/_id";
import SchemeType from "defi/views/_type/_id";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "index",
    component: Schemes
  },
  {
    path: "/mine",
    name: "mine",
    component: Mine
  },
  {
    path: "/orders",
    name: "orders",
    component: () => import("defi/views/orders/index.vue")
  },
  {
    path: "/orders/:id",
    name: "orders-id",
    component: () => import("defi/views/orders/_id.vue")
  },
  {
    path: "/transactions",
    name: "transactions",
    component: () => import("defi/views/transactions/index.vue")
  },
  {
    path: "/transactions/:id",
    name: "transactions-id",
    component: () => import("defi/views/transactions/_id.vue")
  },
  {
    path: "/loan",
    name: "loan",
    component: () => import("defi/views/loan/index.vue")
  },
  {
    path: "/loan/:id",
    name: "loan-id",
    component: () => import("defi/views/loan/_id.vue")
  },
  {
    path: "/:type/contracts",
    name: "type-contracts",
    component: ContractsList
  },
  {
    path: "/:type/contract/:id",
    name: "type-contract-id",
    component: ContractItem
  },
  {
    path: "/:type/:id",
    name: "type-id",
    component: SchemeType
  }
];

export default routes;
